<template>
  <van-tabbar v-model="active" @change="handleChange">
    <van-tabbar-item v-for="item in iconArr" :key="item.tabname" :dot="item.dot && inform">
      <template #icon="props">
        <router-link :to="item.url==$route.path ? '/shop': item.url+item.query ">
          <img class="pointer" :src="item.url==$route.path ? item.active : item.inactive"
            :class="{ 'tabbar-active': props.active || item.url==$route.path }" />
          <p class="tabbar__txt" v-if="item.url!=$route.path">{{
            item.tabname
          }}</p>
        </router-link>
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>
<script>
export default {
  name: 'WsTabbar'
}
</script>
<script setup>
import ajax from "@/utils/request.js";
import { ref ,onMounted} from "vue";
import { useRouter } from "vue-router";
const router = useRouter();
const { currentRoute } = router;
const inform = ref(true);
/**
 * 路由的meta中设置tabbar来显示底部的active
 * 不显示回到首页设置active为-1
 * 购物车为0，订单为1，消息为2，通知为3，事故为4
 */
const meta = currentRoute.value.meta;

const active = ref(-1);
//判断meta.tabbar为0的情况为false出现的问题
if (meta.tabbar && meta.tabbar === 0) {
  active.value = 0
} else if (meta.tabbar) {
  active.value = meta.tabbar;
  if(active.value == 3){
    inform.value = false
  }
} else {
  active.value = -1;
}

// 获取通知信息，如果存在则显示红点
const getInformDot = () => {

  ajax.post("users/getmessagecount").then((res) => {
    inform.value = (res.data > 0 &&  active.value !== 3)? true : false
  })
}

const handleChange = () => {
  if (meta.tabbar && meta.tabbar === 0) {
    active.value = 0
  } else if (meta.tabbar) {
    active.value = meta.tabbar;
  } else {
    active.value = -1;
  }
}

const iconArr = ref([
  {
    url: "/shop/cart", query: '',
    active: require("@/assets/img/icon-home.png"),
    inactive: require("@/assets/img/icon30-2.png"),
    tabname: "购物车",
  },
  {
    url: "/shop/order", query: '',
    active: require("@/assets/img/icon-home.png"),
    inactive: require("@/assets/img/shop1.png"),
    tabname: "订单",
  },
  {
    url: "/shop/msg1", query: '',
    active: require("@/assets/img/icon-home.png"),
    inactive: require("@/assets/img/shop4.png"),
    tabname: "消息",
  },
  {
    url: "/shop/msg2",
    query: '?column_type=9',
    active: require("@/assets/img/icon-home.png"),
    inactive: require("@/assets/img/shop3.png"),
    tabname: "通知",
    dot:true
  },
  {
    url: "/shop/msg3", query: '',
    active: require("@/assets/img/icon-home.png"),
    inactive: require("@/assets/img/shop2.png"),
    tabname: "事故",
  },
]);
onMounted(()=>{
  getInformDot()
})
</script>
<style scoped>
.tabbar__txt {
  font-size: 12px;
  color: #cccccc;
  text-align: center;
  margin-top: 5px;
}
.tabbar-active {
  width: 13.3333vw;
}
.van-tabbar-item__icon img {
  height: 7.4667vw;
}
.van-tabbar-item__icon .tabbar-active {
  height: 13.3333vw;
}
.van-tabbar {
  height: 17.0667vw;
}
</style>